import React from 'react';

const SearchBarSegment = React.forwardRef(({ label, value, placeholder, isActive, onClick, icon, hasError, className }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={`sf-searchbar__segment ${isActive ? 'sf-searchbar__segment--active' : ''} ${hasError ? 'sf-searchbar__segment--error' : ''} ${className || ''}`}
      onClick={onClick}
    >
      {icon && <span className="sf-searchbar__segment-icon">{icon}</span>}
      <div className="sf-searchbar__segment-text">
        <span className="sf-searchbar__segment-label">{label}</span>
        <span className={`sf-searchbar__segment-value ${!value ? 'sf-searchbar__segment-value--placeholder' : ''}`}>
          {value || placeholder}
        </span>
      </div>
    </button>
  );
});

SearchBarSegment.displayName = 'SearchBarSegment';

export default SearchBarSegment;
